$('.nav-category .menu__item--has-dropdown:not(.menu__item--ancestor-active):not(.menu__item--active)').hover(
	function() {
		if ($(window).width() > 1023 && !$(this).hasClass('currently-sliding')) {
			$(this)
				.find('.menu__dropdown')
				.slideDown(200);
		}
	},
	function() {
		if ($(window).width() > 1023) {
			$(this)
				.addClass('currently-sliding')
				.find('.menu__dropdown')
				.slideUp(200, () => {
					$(this).removeClass('currently-sliding');
				});
		}
	}
);

$('.js-slide-up').on('click', function() {
	const $this = $(this);
	$this
		.parents('.js-show')
		.removeClass('js-show')
		.find('.menu__dropdown')
		.slideUp();
});
